"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SectionTypeEnum;
(function (SectionTypeEnum) {
    SectionTypeEnum["ACTIVITY"] = "activity";
    SectionTypeEnum["MASTERY_CHECK"] = "mastery-check";
    SectionTypeEnum["LESSON"] = "lesson";
    SectionTypeEnum["PREQUIZ"] = "prequiz";
    SectionTypeEnum["POSTQUIZ"] = "postquiz";
})(SectionTypeEnum || (SectionTypeEnum = {}));
exports.default = SectionTypeEnum;
